<template>
  <v-dialog v-model="dialog" max-width="800" persistent>
    <v-card tile>
      <v-toolbar flat>
        <v-icon left>{{ titleIcon }}</v-icon>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="closeDialog">
            <v-icon>{{ closeIcon }}</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text v-html="text"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="isReject" text color="red lighten-1" @click="sendRejectState">{{ reject }}</v-btn>
        <v-btn v-if="isConfirm" text color="light-green" @click="sendConfirmState">{{ confirm }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import { mdiClose, mdiHelpCircle } from '@mdi/js'

export default {
  name: 'confirmationDialog',
  props: {
    dialog: Boolean,
    title: String,
    text: String,
    reject: String,
    confirm: String,
    autoClose: {
      type: Boolean,
      default: true
    },
    isConfirm: {
      type: Boolean,
      default: true
    },
    isReject: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    titleIcon: mdiHelpCircle,
    closeIcon: mdiClose
  }),
  methods: {
    closeDialog () {
      this.$emit('confirmation-dialog-closed')
    },
    _sendState (state) {
      this.$emit(state)
      if (this.autoClose) {
        this.closeDialog()
      }
    },
    sendRejectState () {
      this._sendState('confirmation-dialog-rejected')
    },
    sendConfirmState () {
      this._sendState('confirmation-dialog-confirmed')
    }
  }
}
</script>

<style scoped>

</style>
